// extracted by mini-css-extract-plugin
export default {"wrapperCategorie":"Search_wrapperCategorie__kghCE","wrapperAnnunci":"Search_wrapperAnnunci__JCaCv"};